import { NavigationDataResponse } from '@/api/navigationApi/types.gen'

export const resolveStartFlowAction = (
  routeModuleState: NavigationDataResponse['route_module_state'] | undefined
): 'resume' | 'cameraCheck' | 'none' => {
  if (routeModuleState === 'Paused') return 'resume'
  if (routeModuleState === 'Fetched') return 'cameraCheck'
  return 'none'
}

export const shouldRenderAlerts = (cameraCheckVisible: boolean): boolean => !cameraCheckVisible

// Maintenance is a vehicle-wide hard stop the car reports regardless of freeride. During it the
// drive controls are hidden so the screen matches the normal (non-freeride) maintenance view.
export const shouldShowUnexpectedEvents = ({
  isDriving,
  isFreeride,
  shouldStartDropoff,
  isMaintenance,
}: {
  isDriving: boolean
  isFreeride: boolean
  shouldStartDropoff: boolean
  isMaintenance: boolean
}): boolean => (isDriving || isFreeride || shouldStartDropoff) && !isMaintenance

export const shouldShowDriveControls = (isMaintenance: boolean): boolean => !isMaintenance
